/**
 * Once-per-(kind, experience) guard for chain impression events. The chain UI
 * re-renders many times per appearance; this ensures a "shown" event fires only
 * the first time a given kind is displayed for a given experience id. Module-
 * scoped (one active experience per page, like the chain store and ChainSession).
 */
const _seen: Record<string, boolean> = {};

function key(kind: unknown, idexperience: unknown): string {
  return `${String(kind)}:${String(idexperience)}`;
}

/** Returns true the FIRST time (kind, idexperience) is seen; false afterwards. */
function markOnce(kind: string, idexperience: unknown): boolean {
  if (idexperience == null) {
    return false;
  }
  const k = key(kind, idexperience);
  if (_seen[k]) {
    return false;
  }
  _seen[k] = true;
  return true;
}

export default { markOnce };
